<div class="simple_paginator">
  <span [ngClass]="{simple_paginator__firstPage: !isFirstPage}"
        (click)="isFirstPage ? '' : onClickFirstPage()">1</span>
  <span *ngIf="pageNumber > 1"> ... {{pageNumber}}</span>
  <span> of {{ pageCount ? pageCount : '...' }}</span>
  <span *ngIf="!isEndOfSet"
        class="simple_paginator__nextPage"
        (click)="onClickNext()">Next</span>
</div>
